export default __webpack_public_path__ + "static/media/homeLinkBgMb.637a1981.png";